'use strict';
import {module} from '../app';

module.directive('swipeOnClick', [
    '$ionicPopover', function ($ionicPopover) {
      return {
        restrict: 'A',
        link: function (scope, el, attrs) {

          let FAKE_DELTA_X = 7;

          let fakeGestureEvet = function (element, eventType, fakeGesture) {
            let event = document.createEvent("Event");
            event.initEvent(eventType, true, true);
            event.gesture = fakeGesture;
            element.dispatchEvent(event);
          };

          el.on('click', function (e) {

            e.preventDefault();
            e.stopPropagation();

            let isSwiped = scope.$eval(attrs.swipeOnClick);

            if (isSwiped) {
              fakeGestureEvet(el.closest('.item-content')[0], "drag", {
                direction: "right",
                deltaX: FAKE_DELTA_X,
                srcEvent: e
              });
              fakeGestureEvet(el.closest('.item-content')[0], "release", {
                direction: "right",
                deltaX: FAKE_DELTA_X,
                srcEvent: e
              });
            } else {
              fakeGestureEvet(el.closest('.item-content')[0], "drag", {
                direction: "left",
                deltaX: -FAKE_DELTA_X,
                srcEvent: e
              });
              fakeGestureEvet(el.closest('.item-content')[0], "release", {
                direction: "left",
                deltaX: -FAKE_DELTA_X,
                srcEvent: e
              });
            }

          });

          el.on('release', function (e) {

            e.preventDefault();
            e.stopPropagation();

          });

        }
      };
    }
  ]);



// WEBPACK FOOTER //
// ./src/scripts/directives/swipeOnClick.js